import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

import { SUBHOME_DESTAQUE_MAX_ITEMS, SUBHOME_DESTAQUE_TITLE } from './helpers';

const messages = defineMessages({
  titleBlock: {
    id: 'mpf_subhome_destaque_block',
    defaultMessage: 'Destaque (sub-home)',
  },
  title: {
    id: 'mpf_subhome_destaque_title',
    defaultMessage: 'Título da faixa',
  },
  titleHelp: {
    id: 'mpf_subhome_destaque_title_help',
    defaultMessage: 'Em branco, usa "Destaque".',
  },
  items: {
    id: 'mpf_subhome_destaque_items',
    defaultMessage: 'Atalhos',
  },
  itemsHelp: {
    id: 'mpf_subhome_destaque_items_help',
    defaultMessage:
      'Até {max} atalhos. Cada um vira um botão da faixa; atalho sem rótulo ou sem destino não aparece no site.',
  },
  item: { id: 'mpf_subhome_destaque_item', defaultMessage: 'Atalho' },
  label: { id: 'mpf_subhome_destaque_label', defaultMessage: 'Rótulo' },
  href: { id: 'mpf_subhome_destaque_href', defaultMessage: 'Destino' },
  hrefHelp: {
    id: 'mpf_subhome_destaque_href_help',
    defaultMessage:
      'Página do site ou endereço externo. Ao escolher um conteúdo, o rótulo é preenchido com o título dele — rótulo já editado não é sobrescrito.',
  },
  external: {
    id: 'mpf_subhome_destaque_external',
    defaultMessage: 'Abrir em nova aba',
  },
});

/** Campos de um atalho. */
const itemSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.item),
  addMessage: intl.formatMessage(messages.item),
  fieldsets: [
    { id: 'default', title: 'Default', fields: ['label', 'href', 'external'] },
  ],
  properties: {
    label: { title: intl.formatMessage(messages.label) },
    href: {
      title: intl.formatMessage(messages.href),
      description: intl.formatMessage(messages.hrefHelp),
      widget: 'object_browser',
      mode: 'link',
      selectedItemAttrs: ['@id', '@type', 'Title'],
      allowExternals: true,
      initialPath: '/',
    },
    external: {
      title: intl.formatMessage(messages.external),
      type: 'boolean',
    },
  },
  required: ['label'],
});

/**
 * Schema do bloco "Destaque (sub-home)".
 *
 * `activeObject`/`setActiveObject` mantêm o `ObjectListWidget` no modo
 * controlado: `-1` (e não `undefined`) é o que o deixa com tudo fechado — ver
 * `Blocks/Destaques/schema.ts`.
 */
export const mpfSubHomeDestaqueSchema = ({
  intl,
  activeObject,
  setActiveObject,
}: {
  intl: IntlShape;
  activeObject?: number;
  setActiveObject?: (index: number) => void;
}) => ({
  title: intl.formatMessage(messages.titleBlock),
  fieldsets: [{ id: 'default', title: 'Default', fields: ['title', 'items'] }],
  properties: {
    title: {
      title: intl.formatMessage(messages.title),
      description: intl.formatMessage(messages.titleHelp),
      placeholder: SUBHOME_DESTAQUE_TITLE,
    },
    items: {
      title: intl.formatMessage(messages.items),
      description: intl.formatMessage(messages.itemsHelp, {
        max: SUBHOME_DESTAQUE_MAX_ITEMS,
      }),
      widget: 'object_list',
      schema: itemSchema({ intl }),
      activeObject,
      setActiveObject,
    },
  },
  required: [],
});

export default mpfSubHomeDestaqueSchema;
